import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigurableAuthService } from '@anothertrip/anothertrip-ds';
import { catchError, finalize, map, of } from 'rxjs';

import { LoadingService } from '../../../services/loading.service';
import { NavigationContextService } from '../../../services/navigation-context.service';
import { CollaborationRedirectTrigger } from '../constants/redirect-trigger';
import { TaxProfileService } from '../services/tax-profile.service';

export const previewCollaborationGuard: CanActivateFn = (route, state) => {
  const authService = inject(ConfigurableAuthService);
  const router = inject(Router);
  const navigationContext = inject(NavigationContextService);

  const isPreviewRoute: boolean = route?.routeConfig?.path === 'collaboration/preview/:collaborationId';

  if (!authService.isLoggedIn()) {
    if (isPreviewRoute) {
      const redirectUrl: string = state.url.split('?')[0];
      navigationContext.setContext(redirectUrl, {
        trigger: CollaborationRedirectTrigger.RequireAccount,
      });
    }

    return router.createUrlTree(['/login']);
  }

  const loadingService = inject(LoadingService);
  const loaderId = 'preview-collaboration-guard-loading';
  loadingService.setLoading(loaderId, true);

  return inject(TaxProfileService)
    .getOrFetchProfile()
    .pipe(
      map(() => true),
      catchError(() => {
        navigationContext.clearContext();
        return of(router.createUrlTree(['/collaboration/profile-error']));
      }),
      finalize(() => loadingService.setLoading(loaderId, false))
    );
};
